<template>
  <div class="Background">
    <div class="link_location">
      <h2 class="Title">
        {{ $store.getters.t('설정관리') }} <v-icon small class="mdi mdi-chevron-right" />
        {{ $store.getters.t('일반설정') }} <v-icon small class="mdi mdi-chevron-right" />
        <!-- <a href="/admin/user">사용자 정보</a> -->
        <span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('사용자 정보') }}</span>
      </h2>
    </div>
    <!-- <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        사용자 등록
      </h2>

      <div class="link_location">
        설정관리 <v-icon small class="mdi mdi-chevron-right" />
        일반설정 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/admin/user_create">사용자 등록</a>
      </div>
    </div> -->

    <v-card class="pa-5" elevation="0">

      <v-card-title>
        <v-row>
          <v-col>
            <h4>{{ $store.getters.t('정보 수정') }}</h4>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <h4 class="mb-2" style="color:black;">{{ $store.getters.t('유저 이름') }}</h4>
            <v-form >
              <input :value="username" :counter="50" placeholder="이름" class="search-input" disabled ref="nameInput">
            </v-form>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col>
            <h4 class="mb-2" style="color:black;">{{ $store.getters.t('이메일') }}</h4>
            <v-form >
              <input :value="email" placeholder="이메일" class="search-input" ref="emailInput" disabled>
            </v-form>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col>
            <h4 class="mb-2" style="color:black;">{{ $store.getters.t('암호') }}</h4>
            <v-form ref="passwordForm" v-model="valid" lazy-validation>
              <!-- <input v-model="password" :rules="passwordRules" type="password" placeholder="암호" class="search-input"
                ref="passwordInput"> -->
                <input
                  v-model="password"
                  type="password"
                  :placeholder="this.$store.getters.t('암호')"
                  class="search-input"
                  ref="passwordInput"
                  @input="validatePassword"
                />
                <p v-if="passwordError" style="color: red;">{{ passwordError }}</p>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row justify="end" class="bg-purple mt-3 mr-0">
      <v-col v-for="count in 1" :key="count" cols="auto">
        <TextButton :buttonText="$store.getters.t ? $store.getters.t('취소') : '취소'" class="mr-2" @click="cancel" />
        <TextButton :buttonText="$store.getters.t ? $store.getters.t('수정') : '수정'" :loading="loadingCreate" @click="modifyUser" isPrimary />
      </v-col>
    </v-row>

    <div v-if="loadingCreate" class="loading-overlay">
      <div class="spinner"></div>
    </div>

    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />

  </div>
</template>

<script>
import TextButton from '@/components/ui/button/TextButton2.vue';
import UserApi from '@/api/user/UserApi';
import { mapGetters } from 'vuex';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";


export default {
  components: {
    TextButton,
    AppSnackbar
  },
  data() {
    return {
      loadingCreate: false,
      //name: '',
      //email: '',
      password: '',
      passwordRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters long',
        v => /[A-Z]/.test(v) || 'Password must contain at least one uppercase letter',
        v => /[a-z]/.test(v) || 'Password must contain at least one lowercase letter',
        v => /\d/.test(v) || 'Password must contain at least one digit',
        v => /[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/.test(v) || 'Password must contain at least one special character',
      ],
      valid: '',
      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      passwordError: null,
    }
  },
  computed: {
    ...mapGetters('user', ['username', 'email']),
  },
  methods: {
    async modifyUser() {
      this.loadingCreate = true;
      const data = {
        password: this.password,
      }
      const response = await UserApi.changePassword(data);
     
      if(response.status == 200){
        setTimeout(() => {
            this.loadingCreate = false;
            this.snackbar = true;
            this.snackbarText = this.$store.getters.t('정보 수정에 성공했습니다.');
            this.snackbarError = false;
            setTimeout(() => {
              this.$router.push({ path: '/dashboard' });
              this.snackbar = false;
            }, 2000);
        }, 1000);
      } else if(response.status == 422) {
        setTimeout(() => {
              this.loadingCreate = false;
              this.snackbar = true;
              this.snackbarError = true;
              this.snackbarText = this.$store.getters.t('유효성 검사 실패');
              setTimeout(() => {
                this.snackbar = false;
              }, 2000);
          }, 1000);
      } else {
        setTimeout(() => {
              this.loadingCreate = false;
              this.snackbar = true;
              this.snackbarError = true;
              this.snackbarText = this.$store.getters.t('정보 수정 실패');
              setTimeout(() => {
                this.snackbar = false;
              }, 2000);
          }, 1000);
      }
    },
    cancel() {
      this.$router.push({ path: '/dashboard' });
    },
    validatePassword() {
      const rules = [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Password must be at least 8 characters long',
        v => /[A-Z]/.test(v) || 'Password must contain at least one uppercase letter',
        v => /[a-z]/.test(v) || 'Password must contain at least one lowercase letter',
        v => /\d/.test(v) || 'Password must contain at least one digit',
        v => /[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/.test(v) || 'Password must contain at least one special character',
      ];
      
      for (let rule of rules) {
        const result = rule(this.password);
        if (typeof result === "string") {
          this.passwordError = result;
          return;
        }
      }
      
      this.passwordError = "";
    }
    // async userData() {
    //   const response = await UserApi.userDataApi();
    //   this.name = response.name;
    //   this.email = response.email;
    // }
  },
  created() {
    //this.userData();
  },
}
</script>

<style lang="scss" scoped>
.menu_icon {
  text-align: center;
  padding: 20px;
  background: #f8f8f8;
}

.menu_icon {
  cursor: pointer;
}

.menu_icon.active {
  background-color: #b9d8fb;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: 5px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>